// node_modules
import { FC, useContext } from "react";
import { useHistory } from "react-router";
// Contexts
import { CaseContext } from "Stores";
import { DeliveryLayoutContext } from "Providers";
// Components
import { TileSidebarMenuItem } from "../../TileSidebarMenuItem";

export const DocumentSearchTile: FC = () => {
    // Shared states
    const { caseState } = useContext(CaseContext);
    const {
        isRightSidebarCollapsed,
        setIsOnRightSidebarHoverCollapsed,
        isOnRightSidebarHoverCollapsed
    } = useContext(DeliveryLayoutContext);

    // We get history to navigate
    const history = useHistory();

    const onDocumentSearchTileClick = () => {
        const url = `/cases/${caseState.selectedCaseId}/delivery/search/document/`;
        history.replace(url);
    };

    return (
        <TileSidebarMenuItem
            id="document-search-tile"
            text={"Document search"} 
            imageUrl={"/images/tileSidebarImageDocument.png"} 
            onClickHandler={onDocumentSearchTileClick}
            isOnRightSidebarHoverCollapsed={isOnRightSidebarHoverCollapsed}
            setIsOnRightSidebarHoverCollapsed={setIsOnRightSidebarHoverCollapsed}
            isCollapsedSidebarRight={isRightSidebarCollapsed} 
            handleRightSidebarHoveringCollapse={true} />
    );
};